import styled from "styled-components/macro";
import { focusVisible } from "../../styles/a11y";

export const StyledContainer = styled.div`
  position: absolute;
  top: 50px;
  left: 120px;
  z-index: 10000;
  background: var(--menu-color);
  width: 415px;
  text-align: left;
  border-radius: 25px;
  box-shadow: var(--default-drop-shadow);
  color: var(--grey-0);
  overflow: auto;

  hr {
    width: 100%;
    height: 1.5px;
    background-color: var(--divider);
    border-style: none;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;

    label {
      font-size: 16px;
      font-weight: 500;
    }

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 36px);
    }

    h2 {
      margin-top: 18px;
      margin-left: 25px;
      margin-right: 25px;
      margin-bottom: 18px;
      font-size: 16px !important;
    }

    button.refresh-btn {
      background: none !important;
      border: none;
      padding: 0;
      margin: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        path {
          fill: var(--icon-button-fill);
          opacity: var(--icon-button-opacity);
        }
      }
      &:hover {
        svg {
          path {
            opacity: 1;
          }
        }
      }
    }
  }

  .toggle-setting {
    display: flex;
    margin-bottom: 18px;
    margin-top: 18px;
    margin-left: 25px;
    margin-right: 25px;
    align-items: center;
    color: var(--grey-0);
  }

  .check {
    font-size: 16px;
    margin-left: 15px;
    margin-bottom: 10px;

    input[type="checkbox"] {
      transform: scale(1.5);
      background-color: #9b51e0;
      margin-right: 10px;
    }
  }

  h1 {
    font-size: 14px;
    letter-spacing: 0.1em;
    margin: 0;
    font-family: "Inter";
    font-weight: 700;
    color: var(--grey-1);
  }

  ul {
    padding: 0;
    margin: 0;
    display: block;

    .suggested {
      max-height: 0;
      transition: max-height 0.5s ease;

      &.show {
        max-height: 1000px;
      }
    }

    li {
      margin-left: 25px;
      margin-right: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      font-family: "Inter";
      font-weight: 500;
      font-size: 15px;
      margin-bottom: 10px;
      border: 2px solid var(--menu-color-hover);
      border-radius: 8px;
      padding: 15px;
      line-height: 110%;
      box-shadow: 0 0 0 1px transparent;
      position: relative;
      ${focusVisible}
      &:hover {
        background-color: var(--menu-color-hover);
        &:focus-within {
          background-color: var(--menu-color);
        }
      }
      &.custom-guidance {
        align-items: flex-start;
        margin-top: 20px;
        margin-bottom: 25px;
        padding: 6px 10px;
      }
      &:nth-child(3) {
        margin-bottom: 18px;
      }

      p {
        width: 90%;
        line-height: 120% !important;
      }

      .next {
        width: 10px;
      }

      textarea {
        font-family: "Inter";
        font-weight: 500;
        width: 80%;
        background: transparent;
        border: 0px;
        font-size: 15px;
        resize: none;
        padding: 0px;
        min-height: 39.5px;
        color: var(--grey-0);
      }

      #placeholder-text {
        color: var(--grey-1);
        width: 100%;
        position: absolute;
        top: 10px;
        cursor: text;

        a {
          color: var(--grey-1);
          text-decoration: underline;
        }
      }

      ::placeholder {
        color: var(--grey-1);
      }

      button#done {
        padding: 10px 20px;
        border-radius: 6px;
        margin: 0;
        margin-right: -3px;
      }

      &.loading-item {
        cursor: default;

        &:hover {
          background-color: var(--menu-color-hover);
        }

        .items {
          width: 100%;
          .first,
          .second {
            /* background: #c4c4c4; */
            /* background-color: var(--menu-color-hover); */
            border-radius: 20px;
            height: 15px;
            margin: 0;
            opacity: var(--shimmer-opacity); //lighter for dark mode
            mix-blend-mode: var(--shimmer-blend-mode);
          }

          .first {
            width: 90%;
            margin-bottom: 6px;
            margin-top: 4px;
          }
          .second {
            width: 80%;
          }
        }
      }
    }

    li:focus-within:not(:focus-visible) {
      border: 2px solid var(--primary-cta);
      box-shadow: 0 0 0 1px var(--primary-cta);
    }
  }
`;
